export enum ContentType {
	JSON = "application/json",
	PDF = "application/pdf",
	FORM_DATA = "multipart/form-data;",
	PNG = "image/png",
}
